import React, { useEffect, useState } from "react";
import { Header_panel } from "../Useful/Useful";
import { Button, Form } from "reactstrap";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../Useful/useful.css";
import "./user.css";

import {
  TownsGetById,
  UploadFile,
  ProvincegGet,
  UserGetByMobile,
  GetCityByProvinceId,
} from "../../fetch";

export default function EditUser(props) {
  const [usermobile, setusermobile] = useState("");
  const [flagFound, setflagFound] = useState(false);
  const [flagNotFound, setflagNotFound] = useState(false);
  const [searchResult, setsearchResult] = useState([]);
  const [provinces, setprovinces] = useState([]);
  const [userFullName, setuserFullName] = useState("");
  const [userName, setuserName] = useState("");
  const [password, setpassword] = useState("");
  const [mobile, setmobile] = useState("");
  const [image, setimage] = useState("");
  const [userId, setUserId] = useState("");

  const [setting, setSetting] = useState({
    description: "",
    provinceId: "",
    cityId: "",
    name: "",
    phonenumber: "",
    address: "",
    postalCode: "",
    password: "",
    repeatPassword: "",
  });
  const {
    name,

    address,

    description,

    provinceId,
  } = setting;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // setLoading(true);
    TownsGetById(props.id)
      .then((response) => {
        // setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setimage(responseJson.result.image);
        // setcityId(responseJson.result.cityId);
        setSetting({
          name: responseJson.result.name,
          address: responseJson.result.address,

          description: responseJson.result.description,

          provinceId: responseJson.result.provinceId,
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
    // setLoading(true);

    ProvincegGet(0, 999)
      .then((response) => {
        // setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setprovinces(responseJson.result);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });

    // var htmlInput = document.getElementById("name");
    // var htmlInput1 = document.getElementById("address");
    // var htmlInput2 = document.getElementById("description");
    // var htmlInput3 = document.getElementById("provinceId");

    // htmlInput2.oninvalid = function (e) {
    //   e.target.setCustomValidity("لطفا توضیحات  را وارد کنید");
    //   htmlInput2.oninput = function (e) {
    //     e.target.setCustomValidity("");
    //   };
    // };
    // htmlInput.oninvalid = function (e) {
    //   e.target.setCustomValidity("لطفا نام شهرک را وارد کنید");
    //   htmlInput.oninput = function (e) {
    //     e.target.setCustomValidity("");
    //   };
    // };
    // htmlInput1.oninvalid = function (e) {
    //   e.target.setCustomValidity("لطفا آدرس  را وارد کنید");
    //   htmlInput1.oninput = function (e) {
    //     e.target.setCustomValidity("");
    //   };
    // };
    // htmlInput3.oninvalid = function (e) {
    //   e.target.setCustomValidity("لطفا  استان  را وارد کنید");
    //   htmlInput3.oninput = function (e) {
    //     e.target.setCustomValidity("");
    //   };
    // };
  }, [props.id]);

  const onSubmit = (e) => {
    e.preventDefault();

    var Data1 = {
      name: name,
      description: description,
      image: image,

      address: address,

      provinceId: provinceId,
      userId: userId,
    };
    var DataPut = {
      id: props.id && props.id,
      name: name,
      description: description,
      image: image,

      address: address,

      provinceId: provinceId,
      // userId: searchResult.id && searchResult.id,
    };
    var Data2 = {
      name: name,
      description: description,
      image: image,

      address: address,

      provinceId: provinceId,
      userFullName: userFullName,
      userName: userName,
      password: password,
      mobile: mobile,
    };
    flagFound
      ? props.onFormSubmit(Data1)
      : props.id
      ? props.onFormSubmit(DataPut)
      : props.onFormSubmit(Data2);
    setimage("");
    setSetting({
      name: "",
      address: "",
      description: "",

      provinceId: "",
    });
  };
  const handleSelectFile = (event) => {
    setLoading(true);
    UploadFile(event.target.files[0])
      .then((response) => {
        setLoading(false);
        return response.json();
      })
      .then((responseJson) => {
        setimage(responseJson.pathFName);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  const handleChange = (name) => (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    event.persist();
    setSetting((prevState) => ({ ...prevState, [name]: value }));
  };
  const search = () => {
    if (usermobile == "") {
      toast.error("لطفا شماره را وارد کنید");
      return;
    }
    UserGetByMobile(usermobile)
      .then((response) => {
        // setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.success) {
          toast.success("کاربر یافت شد.اطلاعات شهرک را وارد کنید");
          setflagFound(true);
          setuserFullName(responseJson.result.fullname);
          setmobile(responseJson.result.mobile1);
          setuserName(responseJson.result.userName);
          setUserId(responseJson.result.id);
        } else {
          setflagNotFound(true);
          toast.error(responseJson.message);
        }
        // setcityId(responseJson.result.cityId);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="col-lg-12 mypanel shadow">
      <Header_panel
        title={props.id ? " ویرایش شهرک" : "افزودن شهرک"}
        idMenu="#navbarToggleExternalContentSettingAdd1"
      />
      <div className="pos-f-t">
        <div className="collapse" id="navbarToggleExternalContentSettingAdd1">
          <Form onSubmit={onSubmit}>
            <div className="row p-4">
              {!props.id && !flagFound && !flagNotFound ? (
                <div className="col-lg-6">
                  <div class="input-group-prepend">
                    <input
                      name="usermobile"
                      value={usermobile}
                      onChange={(e) => setusermobile(e.target.value)}
                      type="number"
                      class="form-control"
                      placeholder="شماره تماس را وارد کنید..."
                      aria-label=""
                      aria-describedby="basic-addon1"
                    />
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      onClick={() => search()}
                    >
                      جستجو
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
              {flagFound || props.id ? (
                <>
                  {" "}
                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        * نام و نام خانوادگی{" "}
                      </label>
                      <input
                        disabled
                        required
                        // ref={this.fileInput}
                        value={userFullName}
                        id="name"
                        // onChange={handleChange("name")}
                        className="contactInput form-control"
                        name="name"
                        placeholder="نام شهرک..."
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        * نام کاربری{" "}
                      </label>
                      <input
                        disabled
                        required
                        // ref={this.fileInput}
                        value={userName}
                        id="name"
                        // onChange={handleChange("name")}
                        className="contactInput form-control"
                        name="name"
                        placeholder="نام شهرک..."
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        * شماره تماس{" "}
                      </label>
                      <input
                        disabled
                        required
                        // ref={this.fileInput}
                        value={mobile}
                        id="name"
                        // onChange={handleChange("name")}
                        className="contactInput form-control"
                        name="name"
                        placeholder="نام شهرک..."
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        * نام شهرک{" "}
                      </label>
                      <input
                        required
                        // ref={this.fileInput}
                        value={name}
                        id="name"
                        onChange={handleChange("name")}
                        className="contactInput form-control"
                        name="name"
                        placeholder="نام شهرک..."
                      />
                    </div>
                  </div>
                  <div className="form-group textg  col-lg-3">
                    <label className="control-label" htmlFor="provinceId">
                      * استان{" "}
                    </label>
                    <select
                      className="form-control"
                      required
                      name="provinceId"
                      id="provinceId"
                      value={provinceId}
                      onChange={handleChange("provinceId")}
                      onClick={handleChange("provinceId")}
                    >
                      <option value="">---</option>
                      {provinces.map((cat, index) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                      ))
                    </select>
                  </div>
                  <div className="col-lg-12 mb-4 ">
                    <div className="form-group textg ">
                      <label className="control-label" htmlFor="image">
                        انتخاب فایل
                      </label>
                      <div className="custom-file">
                        <input
                          accept="image/*"
                          type="file"
                          className="custom-file-input"
                          id="image"
                          aria-describedby="inputGroupFileAddon01"
                          onChange={handleSelectFile}
                        />
                        <div
                          className="custom-file-label "
                          value={image}
                          htmlFor="inputGroupFile01"
                        >
                          <div className="d-flex justify-content-center">
                            {loading && (
                              <>
                                <Spinner
                                  animation="grow"
                                  variant="info"
                                  size="lg"
                                />
                                <div> عکس در حال بارگزاری است ...</div>
                              </>
                            )}
                          </div>
                          <span className="pad">
                            {" "}
                            آدرس تصویر &larr; {image}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    {image && (
                      <div className="col  mb-2 ">
                        <div className=" m-2 mb-2 ">
                          <img
                            width={150}
                            height={150}
                            // value={item.url}
                            src={`https://macks-b.ir/${image}`}
                            alt={""}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 mt-2">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="address">
                        آدرس
                      </label>
                      <textarea
                        rows="3"
                        value={address}
                        id="address"
                        onChange={handleChange("address")}
                        className="contactInput form-control"
                        name="address"
                        placeholder="آدرس..."
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="description">
                        توضیحات
                      </label>
                      <textarea
                        rows="3"
                        value={description}
                        id="description"
                        onChange={handleChange("description")}
                        className="contactInput form-control"
                        name="description"
                        placeholder="توضیحات..."
                      />
                    </div>
                  </div>
                </>
              ) : (
                flagNotFound && (
                  <>
                    <div className="col-lg-4">
                      <div className="form-group textg">
                        <label className="control-label" htmlFor="userFullName">
                          نام و نام خانوادگی{" "}
                        </label>
                        <input
                          required
                          // ref={this.fileInput}
                          value={userFullName}
                          id="userFullName"
                          onChange={(e) => setuserFullName(e.target.value)}
                          className="contactInput form-control"
                          name="userFullName"
                          placeholder="نام و نام خانوادگی..."
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group textg">
                        <label className="control-label" htmlFor="userName">
                          * نام کاربری{" "}
                        </label>
                        <input
                          required
                          // ref={this.fileInput}
                          value={userName}
                          id="userName"
                          onChange={(e) => setuserName(e.target.value)}
                          className="contactInput form-control"
                          name="userName"
                          placeholder="نام کاربری..."
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group textg">
                        <label className="control-label" htmlFor="name">
                          * رمز عبور{" "}
                        </label>
                        <input
                          required
                          type="password"
                          // ref={this.fileInput}
                          value={password}
                          id="password"
                          onChange={(e) => setpassword(e.target.value)}
                          className="contactInput form-control"
                          name="password"
                          placeholder="رمز عبور ..."
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group textg">
                        <label className="control-label" htmlFor="name">
                          * شماره تماس{" "}
                        </label>
                        <input
                          required
                          // ref={this.fileInput}
                          value={mobile}
                          id="mobile"
                          onChange={(e) => setmobile(e.target.value)}
                          className="contactInput form-control"
                          name="mobile"
                          placeholder="شماره تماس..."
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group textg">
                        <label className="control-label" htmlFor="name">
                          * نام شهرک{" "}
                        </label>
                        <input
                          required
                          // ref={this.fileInput}
                          value={name}
                          id="name"
                          onChange={handleChange("name")}
                          className="contactInput form-control"
                          name="name"
                          placeholder="نام شهرک..."
                        />
                      </div>
                    </div>
                    <div className="form-group textg  col-lg-3">
                      <label className="control-label" htmlFor="provinceId">
                        * استان{" "}
                      </label>
                      <select
                        className="form-control"
                        required
                        name="provinceId"
                        id="provinceId"
                        value={provinceId}
                        onChange={handleChange("provinceId")}
                        onClick={handleChange("provinceId")}
                      >
                        <option value="">---</option>
                        {provinces.map((cat, index) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.name}
                          </option>
                        ))}
                        ))
                      </select>
                    </div>
                    <div className="col-lg-12 mb-5 ">
                      <div className="form-group textg ">
                        <label className="control-label" htmlFor="image">
                          انتخاب فایل
                        </label>
                        <div className="custom-file">
                          <input
                            accept="image/*"
                            type="file"
                            className="custom-file-input"
                            id="image"
                            aria-describedby="inputGroupFileAddon01"
                            onChange={handleSelectFile}
                          />
                          <div
                            className="custom-file-label "
                            value={image}
                            htmlFor="inputGroupFile01"
                          >
                            <div className="d-flex justify-content-center">
                              {loading && (
                                <>
                                  <Spinner
                                    animation="grow"
                                    variant="info"
                                    size="lg"
                                  />
                                  <div> عکس در حال بارگزاری است ...</div>
                                </>
                              )}
                            </div>
                            <span className="pad">
                              {" "}
                              آدرس تصویر &larr; {image}{" "}
                            </span>
                          </div>
                          {image && (
                            <div className="col  mb-5 ">
                              <div className=" m-2 mb-5 ">
                                <img
                                  width={150}
                                  height={150}
                                  // value={item.url}
                                  src={`https://macks-b.ir/${image}`}
                                  alt={""}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 mt-3 ">
                      <div className="form-group textg">
                        <label className="control-label" htmlFor="address">
                          آدرس
                        </label>
                        <textarea
                          rows="3"
                          value={address}
                          id="address"
                          onChange={handleChange("address")}
                          className="contactInput form-control"
                          name="address"
                          placeholder="آدرس..."
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group textg">
                        <label className="control-label" htmlFor="description">
                          توضیحات
                        </label>
                        <textarea
                          rows="3"
                          value={description}
                          id="description"
                          onChange={handleChange("description")}
                          className="contactInput form-control"
                          name="description"
                          placeholder="توضیحات..."
                        />
                      </div>
                    </div>
                  </>
                )
              )}
            </div>
            {loading && (
              <Spinner
                className="buttonProgress"
                animation="border"
                variant="primary"
              />
            )}
            <Button type="submit" color="primary" id="regProdbtn">
              ذخیره
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
